module.exports = __webpack_public_path__ + "img/icon25.9729ce74.svg";